// Generated by scripts/build-ui-icons.mjs.
export { ToggleRight as default } from "../ui/glyphs-7";
